import internalJsonFetch from '../internalJsonFetch'
import { RequestMethod } from '../consts'
import ApiRoutes from '@lib/routes/ApiRoutes'
// import { type ShortcodeRequestResponseData } from '@pages/api/v1/shortcode/upsert'

export default async function upsert({
  createdBy,
  url,
}: {
  createdBy?: string
  url: string
}) {
  const result = await internalJsonFetch<string>({
    authenticated: false,
    body: { createdBy, url },
    requestMethod: RequestMethod.POST,
    url: ApiRoutes.v1.shortcode.upsert,
  })
  return result
}
